import { render, staticRenderFns } from "./Endnotenuebersicht.vue?vue&type=template&id=0bba5fa6&"
import script from "./Endnotenuebersicht.vue?vue&type=script&lang=js&"
export * from "./Endnotenuebersicht.vue?vue&type=script&lang=js&"
import style0 from "./Endnotenuebersicht.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports